import React from "react";
import PropTypes from "prop-types";

const AccountTypeThrottlingMessage = ({ error, user }) => {
  // eslint-disable-next-line no-underscore-dangle
  const errorMessage = error.__html ? error.__html : "";

  return (
    <React.Fragment>
      <svg
        className="tw-mb-2 tw-inline-block"
        style={{ width: "200px", fill: "#2ca591" }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <g>
          <path d="M480,320H32V104H16V352a40.045,40.045,0,0,0,40,40H197.526L177.89,464H152v16H360V464H334.11L318.264,405.9l-15.436,4.21L317.526,464H194.474l19.636-72H456a40.045,40.045,0,0,0,40-40V288H480Zm-24,56H56a24.028,24.028,0,0,1-24-24V336H480v16A24.028,24.028,0,0,1,456,376ZM496,72V272H480V72a24.028,24.028,0,0,0-24-24H56A24.028,24.028,0,0,0,32,72V88H16V72A40.045,40.045,0,0,1,56,32H456A40.045,40.045,0,0,1,496,72ZM153.445,255.6a10.963,10.963,0,0,0,9.519,16.4H349.036a10.964,10.964,0,0,0,9.52-16.4L272.992,105.861a19.57,19.57,0,0,0-33.984,0l-14.919,26.108L210.2,124.031l14.919-26.108a35.572,35.572,0,0,1,61.77,0l85.562,149.735A26.964,26.964,0,0,1,349.036,288H162.964a26.962,26.962,0,0,1-23.41-40.342l61.5-107.627,13.892,7.938ZM264,224H248V136h16Zm-16,16h16v16H248ZM64,96H48V80H64ZM48,112H64v80H48Z" />
        </g>
      </svg>
      <div className="tw-mb-10 tw-text-center">
        <h5 className="tw-text-4xl tw-font-bold tw-m-0">Request throttled!</h5>
        <span className="tw-text-sm">{`(${errorMessage})`}</span>
      </div>
      <div className="tw-text-sm">
        We are sorry but we throttled your request because you have surpassed
        the limits on your account:
        <div
          style={{ maxWidth: "350px" }}
          className="varsome_table tw-mx-auto tw-mt-2 tw-mb-0"
        >
          <table>
            <tbody>
              <tr>
                <td>Account Type</td>
                <td className="tw-text-left tw-font-normal">
                  {user.user_type}
                </td>
              </tr>
              <tr>
                <td className="font-normal">
                  Hourly Limit <small>(60-minute period)</small>
                </td>
                <td className="tw-text-left">
                  {user.is_varsome_premium_subscriber
                    ? `${user?.limits?.premium_hourly_limit} requests`
                    : `${user?.limits?.hourly_limit} requests`}
                </td>
              </tr>
              <tr>
                <td className="font-normal">
                  Daily Limit <small>(24-hour period)</small>
                </td>
                <td className="tw-text-left">
                  {user.is_varsome_premium_subscriber
                    ? `No limit`
                    : `${user?.limits?.daily_limit} requests`}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

AccountTypeThrottlingMessage.propTypes = {
  error: PropTypes.string.isRequired,
  user: PropTypes.shape({
    avatar: PropTypes.string,
    clinvar_submission_api_key: PropTypes.string,
    clinvar_submission_token_id_hashed: PropTypes.string,
    email: PropTypes.string,
    email_public: PropTypes.bool,
    email_verification_needed: PropTypes.bool,
    first_name: PropTypes.string,
    full_name_public: PropTypes.bool,
    group: PropTypes.shape({
      address: PropTypes.string,
      admin_user_name: PropTypes.string,
      is_admin: PropTypes.bool,
      is_owner: PropTypes.bool,
      updated_at: PropTypes.string,
      group_id: PropTypes.string,
      group_type: PropTypes.string,
      group_type_description: PropTypes.string,

      name: PropTypes.string,
      description: PropTypes.string,
      created_at: PropTypes.string,
    }),
    is_varsome_premium_subscriber: PropTypes.bool,
    last_name: PropTypes.string,
    limits: PropTypes.shape({
      hourly_limit: PropTypes.number,
      daily_limit: PropTypes.number,
      premium_hourly_limit: PropTypes.number,
      premium_daily_limit: PropTypes.number,
    }),
    linkedin_url: PropTypes.string,
    name_suffix: PropTypes.string,
    open_id_identifier_hashed: PropTypes.string,
    researchgate_url: PropTypes.string,
    screen_name: PropTypes.string,
    summary: PropTypes.string,
    user_type: PropTypes.string,
    user_type_secondary: PropTypes.string,
  }).isRequired,
};

export default AccountTypeThrottlingMessage;
